import { ImageList, ImageListItem } from "@mui/material";
import { getAssetUrl } from "../directus/utils";

export type PropMediaListProps = {
  media: { directus_files_id: string }[];
  imageListProps?: Partial<React.ComponentProps<typeof ImageList>>;
};

export function CardMediaList({ media, imageListProps }: PropMediaListProps) {
  return (
    <ImageList {...imageListProps}>
      {media.map((item) => (
        <ImageListItem key={item.directus_files_id}>
          <img
            style={{  maxHeight: "100%" }}
            height={imageListProps?.rowHeight}
            crossOrigin="anonymous"
            src={getAssetUrl(
              import.meta.env.VITE_DIRECTUS_URL,
              item.directus_files_id
            )}
            alt={"Media"}
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}
